export const LOCALSTORAGE_SESSION = 'auth-session';
